import { Button, Col, Row } from 'antd';
import styled from 'styled-components';
import { ShareOrderType } from 'typings/api/shareTradeShare';

interface ShareTradeBubbleConfigItem {
  background: string;
  header: string;
  text: string;
}

type ShareTradeBubbleConfig = Record<
  ShareOrderType,
  ShareTradeBubbleConfigItem
>;

export const shareTradeBubbleConfig: ShareTradeBubbleConfig = {
  [ShareOrderType.Unspecified]: {
    background: 'transparent',
    header: 'transparent',
    text: '#333333',
  },
  [ShareOrderType.Buy]: {
    background: '#E5F7F0',
    header: '#CCF1EA',
    text: '#00B897',
  },
  [ShareOrderType.Sell]: {
    background: '#FDEDED',
    header: '#FBDFDF',
    text: '#EE4A49',
  },
};

export const TradeRow = styled(Row)`
  display: flex;
  margin-bottom: 8px;
`;

export const TitleRow = styled(Row)`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-wrap: nowrap;
`;

export const BadgeWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 4px;
  height: 100%;

  img {
    margin-top: -1px;
  }
`;

export const PreviousOrderButton = styled(Button).attrs({ type: 'link' })`
  height: unset;
  text-align: left;
  padding: 6px 12px;
  width: 100%;
  border: 0;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  & > .anticon + span {
    margin-left: 4px;
  }
`;

export const PreviousOrderCol = styled(Col)`
  border-radius: 14px 14px 0 0;
`;

export const PriceText = styled.p<{
  lineThrough?: boolean;
  marginLeft?: string;
}>`
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  margin-left: ${({ marginLeft = '0' }) => marginLeft};
  text-decoration: ${({ lineThrough }) =>
    lineThrough ? 'line-through' : 'none'};
`;

export const TotalInvestmentText = styled(PriceText)`
  color: #b5b5b5 !important;
`;

export const Title = styled.p`
  font-size: 16px;
  line-height: 22px;
  margin: 0;
  text-wrap: nowrap;
`;

export const ContainerRow = styled(Row)<{ orderType?: ShareOrderType }>`
  width: 267px;
  cursor: pointer;
  border-radius: 14px;
  background: ${({ orderType }) =>
    shareTradeBubbleConfig[orderType]?.background};

  & ${TradeRow} ${PriceText}, ${TradeRow} ${Title} {
    color: ${({ orderType }) =>
      shareTradeBubbleConfig[orderType]?.text || '#333333'};
  }

  & ${PreviousOrderButton} {
    color: ${({ orderType }) =>
      shareTradeBubbleConfig[orderType]?.text || '#333333'};
  }

  & ${PreviousOrderCol} {
    background-color: ${({ orderType }) =>
      shareTradeBubbleConfig[orderType]?.header || 'transparent'};
  }
`;

export const ContentButton = styled.button`
  width: 100%;
  height: auto;

  display: flex;
  text-align: left;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;

  & > .ant-row {
    width: 100%;
  }
`;

export const ContentRow = styled(Row)`
  padding: 12px;
`;

export const StatusText = styled.p`
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  color: #b5b5b5;
`;

export const TimeText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #b5b5b5;
  margin: 0;
`;

export const Username = styled.p<{ color?: string }>`
  color: ${({ color = '#333333' }) => color};
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  margin: 0;
`;
